<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="primary" class="mb-3" />

    <v-alert v-if="!cargando && items.length === 0" type="info" dense text>
      No se encontraron listas de precio.
    </v-alert>

    <!-- Card por cada tipoListaPrecio + categoriaUniversidad -->
    <v-card
      v-for="(item, idx) in items"
      :key="idx"
      outlined
      class="mb-4"
      :style="!item.estaActivo ? { border: '2px solid #F44336' } : {}">
      <v-card-title class="py-2 px-4 grey lighten-4 d-flex align-center">
        <v-icon small color="primary" class="mr-2">mdi-format-list-bulleted-type</v-icon>
        <span class="text-subtitle-2 font-weight-bold">{{ item.tipoListaPrecio.nombre }}</span>
        <v-chip small color="primary" dark class="ml-3">{{ item.categoriaUniversidad.nombre }}</v-chip>
        <v-spacer />
        <v-btn
          v-if="item.estaActivo"
          class="mx-1"
          small
          color="error"
          outlined
          :loading="cambiandoEstado[item.id]"
          :disabled="cambiandoEstado[item.id]"
          @click="confirmarCambioEstado(item, false)">
          <v-icon left small>mdi-cancel</v-icon>
          Desactivar
        </v-btn>
        <v-btn
          v-else
          class="mx-1"
          small
          color="success"
          outlined
          :loading="cambiandoEstado[item.id]"
          :disabled="cambiandoEstado[item.id]"
          @click="confirmarCambioEstado(item, true)">
          <v-icon left small>mdi-check-circle</v-icon>
          Activar
        </v-btn>
        <v-btn class="mx-1" small color="primary" outlined @click="$emit('agregar-area', item)">
          <v-icon left small>mdi-plus</v-icon>
          Agregar Área
        </v-btn>
        <v-btn class="mx-1" small text @click="toggleExpandAll(idx)">
          <v-icon left small>{{ isAllExpanded(idx) ? 'mdi-collapse-all' : 'mdi-expand-all' }}</v-icon>
          {{ isAllExpanded(idx) ? 'Colapsar Todo' : 'Expandir Todo' }}
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-3">
        <!-- Acordeón por cada área -->
        <v-expansion-panels v-model="expandedPanels[idx]" multiple class="mb-3">
          <v-expansion-panel v-for="(area, aIdx) in item.areas" :key="aIdx">
            <v-expansion-panel-header class="py-2 px-3 blue-grey lighten-5">
              <div class="d-flex align-center" style="width: 100%">
                <v-icon small class="mr-2" color="blue-grey darken-1">mdi-map-marker</v-icon>
                <span class="text-subtitle-2 font-weight-bold">{{ area.areaUniversidad.nombre }}</span>
                <v-chip x-small label class="ml-2" outlined>{{
                  modalidadesProgramasUniversidadesLabels[area.modalidad]
                }}</v-chip>
                <v-spacer />
                <v-btn
                  small
                  color="orange darken-2"
                  outlined
                  class="mr-2"
                  @click.stop="$emit('editar-area', { item, area })">
                  <v-icon left small>mdi-pencil</v-icon>
                  Editar
                </v-btn>
                <v-btn
                  small
                  color="blue-grey darken-1"
                  outlined
                  class="mr-2"
                  @click.stop="$emit('duplicar-area', { item, area })">
                  <v-icon left small>mdi-content-copy</v-icon>
                  Duplicar
                </v-btn>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-row dense class="pt-3">
                <!-- Card por cada modalidad de pago -->
                <v-col
                  v-for="(mod, mIdx) in ordenarModalidades(area.modalidades)"
                  :key="mIdx"
                  cols="12"
                  :md="area.modalidades.length > 1 ? 6 : 12">
                  <v-card
                    outlined
                    class="fill-height"
                    :style="{
                      borderLeft: mod.modalidadPago === 'credito' ? '3px solid #1976D2' : '3px solid #388E3C',
                    }">
                    <!-- Header modalidad -->
                    <div
                      class="d-flex align-center px-3 py-2"
                      :class="mod.modalidadPago === 'credito' ? 'blue lighten-5' : 'green lighten-5'">
                      <v-icon
                        small
                        :color="mod.modalidadPago === 'credito' ? 'blue darken-2' : 'green darken-2'"
                        class="mr-2">
                        {{ mod.modalidadPago === 'credito' ? 'mdi-credit-card' : 'mdi-cash' }}
                      </v-icon>
                      <span
                        class="text-caption font-weight-bold"
                        :class="
                          mod.modalidadPago === 'credito' ? 'blue--text text--darken-2' : 'green--text text--darken-2'
                        ">
                        {{ mod.modalidadPago.toUpperCase() }}
                      </span>
                    </div>

                    <v-divider />

                    <!-- Tabla conceptos -->
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr class="grey lighten-5">
                            <th>Concepto</th>
                            <th class="text-right">Monto Cuota / Módulo</th>
                            <th class="text-right">N° Cuotas / Módulos</th>
                            <th class="text-right">Monto</th>
                            <th class="text-right">% Desc.</th>
                            <th class="text-right">Precio Mín.</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(con, cIdx) in mod.conceptos" :key="cIdx">
                            <td class="font-weight-medium">{{ con.conceptoPago.nombre }}</td>
                            <td class="text-right">
                              {{ con.numeroCuotas > 0 ? Math.round((con.monto / con.numeroCuotas) * 100) / 100 : 0 }}
                            </td>
                            <td class="text-right">{{ con.numeroCuotas }}</td>
                            <td class="text-right font-weight-medium">{{ con.monto }}</td>
                            <td class="text-right">
                              <v-chip
                                x-small
                                label
                                :color="con.porcentajeMaximoDescuento > 0 ? 'orange lighten-4' : 'grey lighten-3'">
                                {{ con.porcentajeMaximoDescuento }}%
                              </v-chip>
                            </td>
                            <td
                              class="text-right font-weight-bold"
                              :class="
                                mod.modalidadPago === 'credito'
                                  ? 'blue--text text--darken-2'
                                  : 'green--text text--darken-2'
                              ">
                              {{ con.precioTotalMinimo }}
                            </td>
                          </tr>

                          <tr>
                            <td colspan="3" class="font-weight-bold">TOTAL</td>
                            <td class="text-right">
                              <span
                                class="font-weight-bold"
                                :class="
                                  mod.modalidadPago === 'credito'
                                    ? 'blue--text text--darken-2'
                                    : 'green--text text--darken-2'
                                "
                                >{{ mod.conceptos.reduce((sum, con) => sum + Number(con.monto), 0) }}</span
                              >
                            </td>
                            <td></td>
                            <td class="text-right">
                              <span
                                class="font-weight-bold"
                                :class="
                                  mod.modalidadPago === 'credito'
                                    ? 'blue--text text--darken-2'
                                    : 'green--text text--darken-2'
                                ">
                                {{ mod.conceptos.reduce((sum, con) => sum + Number(con.precioTotalMinimo), 0) }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>

    <!-- Diálogo de confirmación -->
    <v-dialog v-model="dialogoConfirmacion" max-width="420" persistent>
      <v-card>
        <v-card-title class="text-h6">
          {{ itemConfirmacion && itemConfirmacion.estaActivo ? 'Desactivar' : 'Activar' }} lista de precio
        </v-card-title>
        <v-card-text>
          ¿Está seguro de que desea
          <strong>{{ itemConfirmacion && itemConfirmacion.estaActivo ? 'desactivar' : 'activar' }}</strong>
          esta lista de precio?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="cambiandoEstado[itemConfirmacion && itemConfirmacion.id]"
            @click="cancelarCambioEstado">
            Cancelar
          </v-btn>
          <v-btn
            :color="nuevoEstado ? 'success' : 'error'"
            :loading="cambiandoEstado[itemConfirmacion && itemConfirmacion.id]"
            :disabled="cambiandoEstado[itemConfirmacion && itemConfirmacion.id]"
            @click="ejecutarCambioEstado">
            {{ nuevoEstado ? 'Activar' : 'Desactivar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ModalidadesProgramasUniversidadesLabels } from '../../utils/constantes';
import listaPrecioService from '../../services/lista-precio.service';
export default {
  name: 'ListadoListaPrecioV3',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalidadesProgramasUniversidadesLabels: ModalidadesProgramasUniversidadesLabels,
      expandedPanels: {},
      cambiandoEstado: {},
      dialogoConfirmacion: false,
      itemConfirmacion: null,
      nuevoEstado: false,
    };
  },
  methods: {
    ordenarModalidades(modalidades) {
      const orden = { contado: 0, credito: 1 };
      return [...modalidades].sort((a, b) => (orden[a.modalidadPago] ?? 2) - (orden[b.modalidadPago] ?? 2));
    },
    isAllExpanded(idx) {
      const item = this.items[idx];
      if (!item || !item.areas) return false;
      const panels = this.expandedPanels[idx];
      return panels && panels.length === item.areas.length;
    },
    confirmarCambioEstado(item, estaActivo) {
      this.itemConfirmacion = item;
      this.nuevoEstado = estaActivo;
      this.dialogoConfirmacion = true;
    },
    cancelarCambioEstado() {
      this.dialogoConfirmacion = false;
      this.itemConfirmacion = null;
    },
    async ejecutarCambioEstado() {
      if (!this.itemConfirmacion) return;
      await this.cambiarEstado(this.itemConfirmacion, this.nuevoEstado);
      this.dialogoConfirmacion = false;
      this.itemConfirmacion = null;
    },
    async cambiarEstado(item, estaActivo) {
      this.$set(this.cambiandoEstado, item.id, true);
      try {
        await listaPrecioService.cambiarEstado(item.id, { estaActivo });
        this.$emit('cambio-estado', { id: item.id, estaActivo });
      } catch {
        // error silenciado
      } finally {
        this.$set(this.cambiandoEstado, item.id, false);
      }
    },
    toggleExpandAll(idx) {
      const item = this.items[idx];
      if (!item || !item.areas) return;
      if (this.isAllExpanded(idx)) {
        this.$set(this.expandedPanels, idx, []);
      } else {
        this.$set(
          this.expandedPanels,
          idx,
          item.areas.map((_, i) => i),
        );
      }
    },
  },
};
</script>
